import { useRef } from 'react';
import { SubscribableCategoryItem } from '../../../utils/subscriptionDetail/types';
import styles from '../../../assets/scss/SubscriptionDetail/NextDeliverySubscription/Accordion.module.scss';
import { scrollCategoryAccordion } from '../../../utils/postMessage';

type Props = {
  id: number;
  isOpen: boolean;
  category: SubscribableCategoryItem;
  onClickHandler: (categoryName: string, id: number, isOpen: boolean) => void;
  children: React.ReactNode;
};

export function CategoryAccordion({ id, isOpen, category, onClickHandler, children }: Props) {
  const contentRef = useRef<HTMLDivElement>(null);
  const columnClass = category.column === 1 ? styles.column1 : styles.column2;

  const handleClick = () => {
    onClickHandler(category.categoryName, id, !isOpen);
  };

  const handleClose = () => {
    handleClick();
    // スクロールを戻す
    if (contentRef.current) {
      scrollCategoryAccordion({ containerHeight: contentRef.current.clientHeight });
    }
  };

  return (
    <div className={styles.accordion}>
      <button
        id={`category_${id}`}
        className={styles.accordionHeader}
        type="button"
        onClick={handleClick}
      >
        <div
          className={styles.accordionHeaderTitle}
          dangerouslySetInnerHTML={{
            __html: category.categoryHtml,
          }}
        />
        {category.categoryImage && (
          <img
            className={styles.accordionHeaderImg}
            src={category.categoryImage}
            alt=""
          />
        )}
        <span className={`${isOpen ? styles.angleUp : styles.angleDown}`} />
      </button>
      <div ref={contentRef}>
        {isOpen && (
          <div className={`${styles.bodyContainer} ${columnClass}`}>
            <div className={styles.body}>{children}</div>
            <button
              className={styles.listClose}
              onClick={handleClose}
            >
              折りたたむ
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
